<template>
  <b-form>
    <!-- Name -->
    <b-form-group id="nameGroup" label="Nombre" label-for="name">
      <b-form-input
        id="name"
        name="name"
        type="text"
        v-model.trim="product.name"
        v-validate="'required|min:5'"
        placeholder="Nombre del producto"/>
      <span class="text-danger">{{ errors.first('name') }}</span>
    </b-form-group>

    <!-- Desc -->
    <b-form-group id="descGroup" label="Descripción" label-for="description">
      <b-form-input
        id="description"
        name="description"
        type="text"
        v-model.trim="product.description"
        v-validate="'min:2'"
        placeholder="Descripción larga"/>
      <span class="text-danger">{{ errors.first('description') }}</span>
    </b-form-group>

    <!-- Provenance -->
    <b-form-group id="provenanceGroup" label="Procedencia" label-for="provenance">
      <b-form-input
        id="provenance"
        name="provenance"
        type="text"
        v-model.trim="product.provenance"
        v-validate="'min:2'"
        placeholder="Procedencia del producto"/>
      <span class="text-danger">{{ errors.first('provenance') }}</span>
    </b-form-group>

    <!-- Quantity -->
    <b-form-group id="quantityGroup" label="Cantidad (Stock)" label-for="quantity">
      <b-form-input
        id="quantity"
        name="quantity"
        type="number"
        v-model.trim="product.quantity"
        v-validate="'required'"
        placeholder="Cantidad"/>
      <span class="text-danger">{{ errors.first('quantity') }}</span>
    </b-form-group>

    <!-- Tipo producto -->
    <b-form-group label="Tipo de producto:">
      <b-form-radio-group
        id="productType"
        name="productType"
        v-validate="'required'"
        v-model="product.type">
        <b-form-radio value="carbon">Carbón</b-form-radio>
        <b-form-radio value="leña">Leña</b-form-radio>
        <b-form-radio value="otros">Otros</b-form-radio>
      </b-form-radio-group>
      <span class="text-danger">{{ errors.first('productType') }}</span>
    </b-form-group>

    <!-- Edit mode only -->
    <template v-if="!isNewProduct">
      <!-- Activo / Inactivo -->
      <b-form-group label="Estado producto:">
        <b-form-radio v-model="product.isDisabled" name="product-status" :value="false">Activo</b-form-radio>
        <b-form-radio v-model="product.isDisabled" name="product-status" :value="true">Inactivo</b-form-radio>
      </b-form-group>
    </template>

    <br>

    <b-button v-if="isNewProduct" @click="validateForm" variant="primary">
      Crear Producto
      <b-spinner v-if="isProductBtnLoading" small type="grow"></b-spinner>
    </b-button>
    <b-button v-else @click="validateForm" variant="primary">
      Actualizar Producto
      <b-spinner v-if="isProductBtnLoading" small type="grow"></b-spinner>
    </b-button>
  </b-form>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductForm',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'isProductBtnLoading'
    ]),
    isNewProduct () {
      return this.$route.name === 'ProductNew'
    }
  },
  methods: {
    onCreate () {
      const data = {
        ...this.product,
        isDisabled: false
      }
      this.$emit('onCreate', data)
    },
    onUpdate () {
      this.$emit('onUpdate', this.product)
    },
    validateForm () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.isNewProduct ? this.onCreate() : this.onUpdate()
          }
        })
    }
  }

}
</script>
